var _defs, _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreOrderTimeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_447_1",
    "data-name": "Component 447 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #707070;\n      }\n\n      .cls-4 {\n        stroke-width: .45px;\n      }\n\n      .cls-4, .cls-2 {\n        stroke: #707070;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 1.35px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7744",
    "data-name": "Rectangle 7744",
    className: "cls-1",
    y: 0,
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.34,21.72v-2.81h-.89v3.16l2.14,2.12.62-.62-1.87-1.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.9,26.35c-1.25,0-2.31-.44-3.19-1.31-.88-.88-1.31-1.94-1.31-3.19s.44-2.31,1.31-3.19c.88-.88,1.94-1.31,3.19-1.31,1.25,0,2.31.44,3.19,1.31.88.88,1.31,1.94,1.31,3.19s-.44,2.31-1.31,3.19c-.88.88-1.94,1.31-3.19,1.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.98,10.49c-.17-.3-.41-.54-.72-.72l-7.61-4.37c-.15-.09-.31-.16-.48-.2-.17-.04-.33-.06-.51-.06s-.34.02-.5.06c-.16.04-.32.11-.48.2l-7.61,4.37c-.32.18-.56.42-.73.72-.17.3-.25.63-.25.98v8.61c0,.36.08.69.25.98.17.29.41.53.73.71l8,4.61v-1.86l-7.2-4.18c-.06-.04-.1-.08-.13-.13-.03-.05-.04-.11-.04-.17v-7.94l7.95,4.61,7.98-4.6v4.01h1.61v-4.66c0-.35-.08-.68-.25-.98ZM15.66,14.88l-7.07-4.1,6.89-3.99c.06-.04.12-.06.18-.06s.12.02.18.06l6.89,3.99-7.07,4.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreOrderTimeline);
export default __webpack_public_path__ + "static/media/PreOrderTimeline.b3c72f860d9b62e1c1523b7a3d7639f4.svg";
export { ForwardRef as ReactComponent };